import { Select } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  AdminEditUserMutation,
  AdminEditUserMutationVariables,
  UserFragment,
} from "gql/graphql";
import { supportedTranslationLanguages } from "modules/utils/translation";
import { useMutation } from "@apollo/client";
import ADMIN_EDIT_USER_MUTATION from "../_networking/admin-edit-user";
import { UserPreferenceName } from "modules/utils/Constants";

interface IProps {
  user: UserFragment;
}

const userPreferenceName: UserPreferenceName = "LOCALE";

const AdminEditUserLanguage = ({ user }: IProps) => {
  const [adminEditUserMutationAPI] = useMutation<
    AdminEditUserMutation,
    AdminEditUserMutationVariables
  >(ADMIN_EDIT_USER_MUTATION);

  const defaultLanguage = user.userPreferenceList.find(
    (pref) => pref.name === userPreferenceName,
  )?.value;

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      adminEditUserMutationAPI({
        variables: {
          id: user.id,
          input: {
            userPreferenceList: [
              {
                name: "LOCALE",
                value: e.target.value,
              },
            ],
          },
        },
      });
    },
    [adminEditUserMutationAPI, user.id],
  );

  return (
    <Select
      placeholder="Select One"
      fontSize={14}
      defaultValue={defaultLanguage}
      onChange={onChange}
    >
      {supportedTranslationLanguages.map(([langCode, langName]) => (
        <option key={langCode} value={langCode}>
          {langName}
        </option>
      ))}
    </Select>
  );
};

export default memo(AdminEditUserLanguage);
